import React from "react";
import { ConnectedProps, connect } from "react-redux";
import "./index.css";
import MapComponent from "../../components/Map";
import { ReducerState } from "../../types";
import DetectionAlert from "../../components/Alerts/DetectionAlert";
import TrapAlert from "../../components/Alerts/TrapAlert";

const mapStateToProps = (state: ReducerState) => {
  return {
    selected: state.devices?.selected?.uuid || null,
  };
};

const connector = connect(mapStateToProps, {});

type Props = ConnectedProps<typeof connector> & {
  // Extra props go here
};

const Home: React.FC<Props> = () => {
  return (
    <div className="mx-6 flex h-full">
      <div className="w-100 max-w-100">
        <DetectionAlert />
        <TrapAlert />
      </div>
      <div className="flex-1 ml-6">
        <MapComponent />
      </div>
    </div>
  );
};

export default connector(Home);
